import React from 'react';

export const onBoardingSteps = {
  'step-1': {
    heading: 'Company Profile',
    subheading: 'Please verify your company details as mentioned below',
  },
  'step-2': {
    heading: 'Upload Employee Data',
    subheading:
      'Please upload and verify the list of employees for your company',
  },
  'step-3': {
    heading: 'Verify the Legal Documents',
    subheading:
      'A mistake in this section can lead to delays in the onboarding process. Please follow all instructions very carefully',
  },
};

export const afterUpload = {
  heading: 'Employee Data Upload Completed',
  subheading: 'Please check the status of the upload below.',
};

export const fileDataFormat = '.csv files';

export const fileDataSize = 'not more than 5 MB';

export const successTitle = 'Company profile verified successfully!';

export const successSubtitle =
  'You can now start using your dashboard to create programs.';

export const sampleFileDataFormat =
  'Please upload the file in format provided in the sample';

export const verficationLegalLabel =
  'We will verify the legal entity with this information';

export const validateDetailsLabel = () => {
  return (
    <>
      I hereby verify, that details mentioned above are correct and we are
      agreeing to details mentioned in CEF,
      <a
        href='https://www.zomato.com/conditions'
        rel='noreferrer'
        target='_blank'
      >
        {' '}
        Terms of Service
      </a>{' '}
      and{' '}
      <a href='https://www.zomato.com/privacy' rel='noreferrer' target='_blank'>
        Privacy Policy.
      </a>
    </>
  );
};
